<template>
    <div class="whrte">
        <div class="head">
            微叮咚
            <button @click="goBack">返回</button>
        </div>
        <img :src="ossImgPath+'banner_online.png'" alt="" class="banner">
        <div class="code">
            <img :src=" appletsPath +'/member_store/xcx_code?store_id='+this.store_id +'&'+'company=1'" alt="">
            <p>
                长按扫描或截图保存
                <br>  立即体验积分商城小程序
            </p>
        </div>
        <img :src="ossImgPath+'rhsyxcx.png'" alt="" class="botimgh">
        <img :src="ossImgPath+'xtxld.png'" alt=""  class="botimgh">
    </div>
</template>

<script>
    export default {
        data(){
            return{
                store_id: localStorage.getItem("store_id") || '4326648'
            }
        },
        created(){
            console.log(this.store_id)
        },
        methods:{
            goBack(){
                this.$router.back()
            }
        }
    }
</script>
<style scoped>
    .whrte{
        width: 100%;
        display: block;
        background: #fff;
        padding-bottom: 2rem;

    }
    .head{
        color: #000000;
        font-size: 0.96rem;
        padding: 0.8rem;
    }
    .head button{
        color: #fff;
        font-size: 0.56rem;
        width:2.4rem;
        line-height: 1.04rem;
        height:1.04rem;
        background:linear-gradient(90deg,rgba(234,77,68,1),rgba(231,97,88,1));
        border-radius:0.52rem;
        float: right;
    }
    .banner{
        width: 100%;
    }
    .code{
        padding: 1.6rem 0.6rem;
        position: relative;
    }
    .code img{
        width: 5.32rem;
        height: 5.32rem;
    }
    .code p{
        color: #666666;
        font-size: 0.6rem;
        position: absolute;
        right: 1.3rem;
        width: 6.8rem;
        top: 3.38rem;
        text-align: center;
    }
    .title1{
        width: 9.2rem;
        margin:  0 2.9rem;
    }
    .botimgh{
        width: 100%;
        padding-top: 1rem;
    }
</style>
